import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { ButtonAddComponent } from '@component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from '@component/button-close-dialog/button-close-dialog.component';
import { ButtonDeleteComponent } from '@component/button-delete/button-delete.component';
import { ButtonSaveComponent } from '@component/button-save/button-save.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CasoDto } from '@models/caso/casoDto.model';
import { CreateCasoRequest } from '@models/caso/createCasoRequest.model';
import { UpdateCasoRequest } from '@models/caso/updateCasoRequest.model';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { CasoService } from '@services/caso/caso.service';
import { EstadoCasoService } from '@services/estadoCaso/estadoCaso.service';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoCasoService } from '@services/tipoCaso/tipoCaso.service';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { ListExpedienteSimpleComponent } from '@views/expedientes/list-expediente-simple/list-expediente-simple.component';
import { ListExpedienteComponent } from '@views/expedientes/list-expediente/list-expediente.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, ListExpedienteComponent, MatTabsModule, ButtonCloseDialogComponent, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, ListExpedienteSimpleComponent],
  selector: 'app-dialog-form-caso',
  templateUrl: './dialog-form-caso.component.html',
  styleUrls: ['./dialog-form-caso.component.css']
})
export class DialogFormCasoComponent {
  expedientes!: ExpedienteDto[];
  caso!: CasoDto;
  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  formBuilder: FormBuilder = new FormBuilder;
  tiposCaso!: BaseDto[];
  estadosCaso!: BaseDto[];
  form: any;
  constructor(
    public dialogRef: MatDialogRef<DialogFormCasoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private tipoCasoService: TipoCasoService,
    private casoService: CasoService,
    private estadoCasoService: EstadoCasoService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private expedienteService: ExpedienteService

  ) {

    this.caso = this.data?.item || {};
  }

  ngOnInit(): void {
    this.getAllTiposCaso();
    this.getAllEstadoCaso();

    if(this.data?.item?.id){
      this.getAllExpedienteByCaso(this.data?.item?.id)
    }
    this.setForm();
  }

  setForm(){
 this.form = this.formBuilder.group({
      Id: [this.caso.id || null],
      Activo: [this.caso.activo || false],
      Descripcion: [this.caso.descripcion || null],
      Caratula: [this.caso.caratula || '', Validators.compose([Validators.required])],
      FechaComienzo: [this.caso.fechaComienzo || new Date().toISOString(), Validators.compose([Validators.required])],
      FechaFinalizacion: [this.caso.fechaFinalizacion || null],
      IdTipoCaso: [this.caso.tipoCaso?.id || null],
      IdEstadoCaso: [this.caso.estadoCaso?.id || null],
    });
  }


  getAllTiposCaso() {
    this.spinner.show("spTiposCaso")
    this.tipoCasoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposCaso")
          this.tiposCaso = data
        },
        error => {
          this.spinner.hide("spTiposCaso")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadoCaso() {
    this.spinner.show("spEstadosCaso")
    this.estadoCasoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spEstadosCaso")
          this.estadosCaso = data
        },
        error => {
          this.spinner.hide("spEstadosCaso")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllExpedienteByCaso(idCaso: number) {
    this.spinner.show('spExpediente')
    this.expedienteService.getAllByCaso(idCaso)
      .subscribe(
        data => {
          this.spinner.hide('spExpediente')
          this.expedientes = data
        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        })
  }

  setCreateCasoRequest(): CreateCasoRequest {

    const createCasoRequest = new CreateCasoRequest();

    createCasoRequest.activo = true
    createCasoRequest.caratula = this.form.controls['Caratula'].value;
    createCasoRequest.fechaComienzo = this.form.controls['FechaComienzo'].value;
    createCasoRequest.fechaFinalizacion = this.form.controls['FechaFinalizacion'].value;
    createCasoRequest.idEstadoCaso = this.form.controls['IdEstadoCaso'].value;
    createCasoRequest.idTipoCaso = this.form.controls['IdTipoCaso'].value;
    createCasoRequest.descripcion = this.form.controls['Descripcion'].value;

    return createCasoRequest
  }

  setUpdateCasoRequest(): UpdateCasoRequest {

    const updateCasoRequest = new UpdateCasoRequest();

    updateCasoRequest.id = this.form.controls['Id'].value;
    updateCasoRequest.activo = this.form.controls['Activo'].value;
    updateCasoRequest.caratula = this.form.controls['Caratula'].value;
    updateCasoRequest.fechaComienzo = this.form.controls['FechaComienzo'].value;
    updateCasoRequest.fechaFinalizacion = this.form.controls['FechaFinalizacion'].value;
    updateCasoRequest.idEstadoCaso = this.form.controls['IdEstadoCaso'].value;
    updateCasoRequest.idTipoCaso = this.form.controls['IdTipoCaso'].value;
    updateCasoRequest.descripcion = this.form.controls['Descripcion'].value;

    return updateCasoRequest
  }

  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spCaso")
    this.casoService.create(this.setCreateCasoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spCaso")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.router.navigate(['/expedientes/create'], { queryParams: { idCaso: data.id } });
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: data });
        },
        error => {
          this.spinner.hide("spCaso")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spCaso")
    this.casoService.update(this.setUpdateCasoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spCaso")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: data });
        },
        error => {
          this.spinner.hide("spCaso")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spCaso")
    this.casoService.delete(this.data.item.id)
      .subscribe(
        data => {
          this.spinner.hide("spCaso")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: data });
        },
        error => {
          this.spinner.hide("spCaso")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  getById(id: number) {
    this.spinner.show("spCaso")
    this.casoService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spCaso")
          this.caso = data
          this.setForm();
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: data });
        },
        error => {
          this.spinner.hide("spCaso")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }


  onReset() {
    this.form.reset();
  }


  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
